import { Spinner } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

const Root = styled.div`
  text-align: center;
  padding-block-start: 40px;
  padding-block-end: 40px;
`;

const Loading = () => (
  <Root>
    <Spinner size="large" />
  </Root>
);

export default Loading;
